import { BaseApiResponse, ThirdParty } from '@enmon/commons/lib/tools';
import { notification } from 'antd';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';
import { ThirdPartiesFilter } from 'services/api/thirdParties';
import { useServices } from 'services/useServices';
import { QUERY_KEYS } from 'utils/queryKeys';

export const useThirdParties = (
  filter: ThirdPartiesFilter,
  options: Pick<UseQueryOptions, 'staleTime' | 'cacheTime'> = {},
): UseQueryResult<BaseApiResponse<ThirdParty[]>> => {
  const {
    api: { thirdPartiesApiClient },
  } = useServices();

  return useQuery({
    ...options,
    queryKey: QUERY_KEYS.thirdParties.filter(filter),
    queryFn: async ({ signal }) => await thirdPartiesApiClient.find(filter, { signal }),
    onError: error => {
      notification.error({
        message: 'Failed to fetch third parties',
        description: error instanceof Error ? error.message : 'Unknown error',
      });
    },
    // 1 minute
    staleTime: 1000 * 60,
    cacheTime: 1000 * 60,
  });
};
